import { useState } from 'react'

import { DropdownMenuStatus } from '~/shared/types/dropdownMenu.types'

export default function useDropdownMenu(
  sectionRef: React.RefObject<HTMLDivElement>,
  sectionContentRef: React.RefObject<HTMLDivElement>,
): {
  closeDropdownMenu: () => void
  handleOnDropdownMenuToggle: () => void
  openDropdownMenu: () => void
  status: DropdownMenuStatus
} {
  const [status, setStatus] = useState(DropdownMenuStatus.CLOSED)

  const openDropdownMenu = (): void => {
    if (sectionRef.current && sectionContentRef.current) {
      const section = sectionRef.current
      const sectionContent = sectionContentRef.current

      section.style.height = `${sectionContent.scrollHeight}px`
      section.ontransitionend = () => {
        setStatus(DropdownMenuStatus.OPEN)
        sectionContent.style.opacity = '100%'
        sectionContent.style.transition = 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1)'
      }
    }
  }

  const closeDropdownMenu = (): void => {
    if (sectionRef.current && sectionContentRef.current) {
      const section = sectionRef.current
      const sectionContent = sectionContentRef.current

      section.style.height = '0'
      sectionContent.style.opacity = '0'
      sectionContent.style.transition = 'none'
      section.ontransitionend = () => {
        setStatus(DropdownMenuStatus.CLOSED)
      }
    }
  }

  const handleOnDropdownMenuToggle = (): void => {
    if (status === DropdownMenuStatus.CLOSED) {
      openDropdownMenu()
    }

    if (status === DropdownMenuStatus.OPEN) {
      closeDropdownMenu()
    }
  }

  return {
    closeDropdownMenu,
    handleOnDropdownMenuToggle,
    openDropdownMenu,
    status,
  }
}
